<div class="container-fluid mt-5">
  <div class="row registration-section">
    <div class="col-12 p-0">
      <nb-card class="mx-0">
        <nb-card-header class="d-flex section-header">
          Registration form
          <!-- <mat-icon
            class="ml-3"
            matTooltip="Identify your visitors and collect specific data about certain personas by creating your unique data collection form."
            matTooltipPosition="above"
          >
            help_outline
          </mat-icon> -->
        </nb-card-header>
        <nb-card-body class="body-content" *ngIf="formElements.controls" cdkDropList (cdkDropListDropped)="drop($event)">
          <div class="container-fluid">
            <div class="row m-0">
              <div class="col-12 my-3">
                <div class="tw-flex tw-flex-wrap tw-items-start tw-gap-x-12 [&_ngx-form-languages_.tag-list]:!tw-w-max [&_ngx-form-languages_.tag-list]:tw-max-w-full">
                  <ngx-form-languages class="tw-w-max tw-shrink" [form]="form" [tempform]="form"></ngx-form-languages>
                  <ngx-form-social-login [form]="form"></ngx-form-social-login>
                </div>
              </div>
            </div>
            <div class="row m-0">
              <div class="col-xl-8 col-lg-11 col-md-12 col-sm-12 col-xs-12">
                <div class="row m-0 fields-title">
                  <div class="col-lg-6 col-sm-6 text-center title">Field Type</div>
                  <div class="col-lg-6 col-sm-6 text-center title">Field Label</div>
                </div>
                <nb-card *ngFor="let element of formElements.controls; let i = index" cdkDrag>
                  <ng-container>
                    <nb-card-header class="form-elements-header">
                      <div class="drag-title d-flex row-gap-2 flex-wrap align-items-start">
                        <div class="d-flex col-sm-12 p-0">
                          <mat-icon class="ml-3 flex-shrink-0" cdkDragHandle> drag_indicator </mat-icon>
                          <ngx-personas-form-element
                            [isDTCMRequiredField]="isLegalServiceRequiredField(element)"
                            [eventLegalSetup]="eventLegalSetup"
                            [name]="element.controls['name']"
                            [label]="element.controls['label']"
                            [isUnique]="element.controls['is_unique']"
                            [isRequired]="element.controls['is_required']"
                            [isDisabledOnline]="element.controls['is_disable_online']"
                            [isDisabledOnsite]="element.controls['is_disable_onsite']"
                            [values]="element.controls['form_element_values']"
                            [type]="element.controls['form_element_type_id']"
                            [elementTypes]="elementTypes()"
                            [group]="element"
                            [form]="form"
                            [formElements]="formElements"
                            [elementIndex]="i"
                            [disableRequiredChanges]="disableRequiredChanges(element)"
                            [disableRequiredOnlineChanges]="disableRequiredOnlineChanges(element)"
                            [disableUniqueChanges]="disableUniqueChanges(element)"
                            [disableDeleteChanged]="disableDelete(element)"
                            (deleteFieldChanged)="deleteField(i, element)"
                            (openConditionModalEvent)="openConditionModal($event)"
                          >
                          </ngx-personas-form-element>
                        </div>
                      </div>
                    </nb-card-header>
                  </ng-container>
                </nb-card>
              </div>
            </div>
          </div>
        </nb-card-body>
        <nb-card-footer>
          <button nbButton fullWidth (click)="addNewElement()" class="my-2 d-flex flex-row align-content-center add-field-button" type="button" role="button">
            <span class="fas fa-plus fa-md mx-2"></span>
            Add a field
          </button>
        </nb-card-footer>
      </nb-card>
    </div>
  </div>
</div>

<!-- Single Condition Modal (shared by all fields) -->
<modal
  [id]="conditionModalId"
  [header]="modalHeader"
  [showFooterDivider]="true"
  [showHeaderDivider]="true"
  [widthClass]="'tw-w-[500px] tw-max-w-[90vw]'"
  [heightClass]="'tw-h-auto tw-max-h-[80vh]'"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="true"
  (onCloseModal)="onModalClosed()"
>
  <div slot="body" class="tw-px-6 tw-py-4">
    <!-- Description -->
    <p class="tw-text-gray-600 tw-text-sm tw-mb-4">{{ descriptionText }}</p>

    <!-- No select fields available message -->
    <div *ngIf="!hasSelectFields()" class="tw-text-gray-500 tw-text-center tw-py-8">
      <p class="tw-mb-2">No select fields available</p>
      <p class="tw-text-xs">Add Single Select or Multiple Select fields to your form to use conditional logic.</p>
    </div>

    <!-- Field selection -->
    <div *ngIf="hasSelectFields()" class="tw-space-y-4">
      <ng-container *ngFor="let otherElement of getSelectFields()">
        <div class="tw-border tw-border-gray-200 tw-rounded-lg tw-p-3 tw-mt-2">
          <!-- Field checkbox -->
          <nb-checkbox
            [ngModel]="isFieldSelected(otherElement.controls['name'].value)"
            (ngModelChange)="toggleConditionField(otherElement.controls['name'].value, $event)"
            [disabled]="isSelectedElementDTCMRequired()"
            status="basic"
            class="tw-font-medium"
          >
            {{ getOtherFieldLabel(otherElement) }}
          </nb-checkbox>

          <!-- Value selection for selected field -->
          <div *ngIf="isFieldSelected(otherElement.controls['name'].value)" class="tw-mt-3 tw-ml-6 tw-border-l-2 tw-border-blue-300 tw-pl-3">
            <p class="tw-text-xs tw-text-gray-500 tw-mb-2">Select values that should trigger this condition:</p>

            <!-- Search input for Country field -->
            <div *ngIf="shouldShowSearch(otherElement)" class="tw-mb-2">
              <input
                type="text"
                [(ngModel)]="countrySearchTerm"
                placeholder="Search..."
                class="tw-w-full tw-px-3 tw-py-1.5 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500 focus:tw-border-blue-500"
              />
            </div>

            <!-- Value checkboxes -->
            <div class="tw-space-y-1 tw-max-h-40 tw-overflow-y-auto">
              <ng-container *ngFor="let valueOption of getFilteredValues(otherElement); trackBy: trackByValueName">
                <div class="tw-py-0.5">
                  <nb-checkbox
                    [ngModel]="isConditionValueSelected(otherElement.controls['name'].value, getValueSlug(valueOption))"
                    (ngModelChange)="toggleConditionValueSelection(otherElement.controls['name'].value, getValueSlug(valueOption), $event)"
                    [disabled]="isSelectedElementDTCMRequired()"
                    status="basic"
                  >
                    <span class="tw-text-sm">{{ getValueDisplayName(valueOption) }}</span>
                  </nb-checkbox>
                </div>
              </ng-container>

              <!-- No options message -->
              <p *ngIf="!getOtherFieldValues(otherElement)?.length" class="tw-text-xs tw-text-gray-400 tw-italic">No options available for this field</p>

              <!-- No search results message (only for Country field) -->
              <p
                *ngIf="shouldShowSearch(otherElement) && getOtherFieldValues(otherElement)?.length && !getFilteredValues(otherElement)?.length"
                class="tw-text-xs tw-text-gray-400 tw-italic"
              >
                No results found for "{{ countrySearchTerm }}"
              </p>
            </div>

            <!-- Validation warning -->
            <small *ngIf="!getFieldValue(otherElement.controls['name'].value)" class="tw-text-red-500 tw-text-xs tw-block tw-mt-2"> Please select at least one value </small>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div slot="footer" class="tw-flex tw-justify-end tw-gap-3 tw-px-6 tw-py-4 tw-border-t tw-border-gray-200">
    <button
      type="button"
      class="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-lg tw-transition-colors"
      [ngClass]="{
        'tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 hover:tw-bg-gray-50': hasValidModalConditions(),
        'tw-text-gray-400 tw-bg-gray-100 tw-border tw-border-gray-200 tw-cursor-not-allowed': !hasValidModalConditions()
      }"
      [disabled]="!hasValidModalConditions()"
      (click)="tryCloseConditionModal()"
    >
      Done
    </button>
  </div>
</modal>
